import {useMemo} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {EGlobalSlug, IGlobal, TGlobalSlug} from '../models'
import {searchGlobalByKey} from '../services'
import {RootState} from '../store/RootReducer'

const useGlobalList = (key: EGlobalSlug) => {
  const globalRedux = useSelector<RootState>(
    ({global}) => global.globalParams,
    shallowEqual
  ) as IGlobal

  return useMemo(() => {
    const statuses: IGlobal[] = searchGlobalByKey(globalRedux, key)

    if (statuses !== null) {
      return statuses.map((status) => ({
        label: status.value,
        value: status.code,
      }))
    } else {
      return []
    }
  }, [globalRedux, key])
}

export const useGlobalParams = () => {
  const userStatusList = useGlobalList(EGlobalSlug.USER_STATUS)
  const taskStatusList = useGlobalList(EGlobalSlug.TASK_STATUS)
  const taskPriorityList = useGlobalList(EGlobalSlug.TASK_PRIORITY)
  const taskProgressList = useGlobalList(EGlobalSlug.TASK_PROGRESS)
  const taskReminderList = useGlobalList(EGlobalSlug.TASK_REMINDER)
  const taskRecurringFrequencyList = useGlobalList(EGlobalSlug.TASK_RECURRING_FREQUENCY)
  const userLevelList = useGlobalList(EGlobalSlug.USER_LEVEL)
  const clientStatusList = useGlobalList(EGlobalSlug.CLIENT_STATUS)
  const regexList = useGlobalList(EGlobalSlug.REGEX)
  const genderList = useGlobalList(EGlobalSlug.GENDER)
  const utcList = useGlobalList(EGlobalSlug.UTC_OFFSET)

  return useMemo(
    (): Record<TGlobalSlug, {label?: string; value?: string}[]> => ({
      USER_STATUS: userStatusList,
      TASK_STATUS: taskStatusList,
      TASK_PRIORITY: taskPriorityList,
      TASK_PROGRESS: taskProgressList,
      TASK_REMINDER: taskReminderList,
      TASK_RECURRING_FREQUENCY: taskRecurringFrequencyList,
      USER_LEVEL: userLevelList,
      CLIENT_STATUS: clientStatusList,
      REGEX: regexList,
      GENDER: genderList,
      UTC_OFFSET: utcList,
    }),
    [
      userStatusList,
      taskStatusList,
      taskPriorityList,
      taskProgressList,
      taskReminderList,
      taskRecurringFrequencyList,
      userLevelList,
      clientStatusList,
      regexList,
      genderList,
      utcList,
    ]
  )
}
